import React, { useState } from "react";
import { BlackAndWhite } from "../../../../../../themes/Colors";

const StoreDropDown = ({
  data,
  setSelectedStore,
  selectedStore,
  setSelectedStoreId,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedType, setType] = useState("Click here to select Store");
  const [hover, setHover] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        height: 80,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        onClick={open ? null : () => setOpen(true)}
        style={{
          borderStyle: "solid",
          width: "90%",
          height: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderWidth: 0.5,
          textAlign: "left",
          position: "relative",
          cursor: "pointer",
        }}
      >
        <div style={{ width: "100%", textAlign: "left", marginLeft: 10 }}>
          {selectedStore ? selectedStore : selectedType}
        </div>
        <div
          style={{
            position: "absolute",
            height: open ? 200 : 0,
            overflow: data
              ? data.length >= 5
                ? "scroll"
                : "hidden"
              : "hidden",
            width: "100%",
            transition: "all 0.3s",
            top: 0,
            WebkitBoxShadow: open ? "0px 0px 10px 5px #00000033" : null,
          }}
        >
          <div
            onMouseOver={() => setHover("all")}
            onMouseOut={() => setHover(null)}
            onClick={() => {
              setOpen(false);
              setType("All");
              setSelectedStore("All");
            }}
            style={{
              backgroundColor:
                hover === "all"
                  ? BlackAndWhite.primary
                  : BlackAndWhite.secondary,
              width: "100%",
              height: 40,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 100,
              // borderStyle: "solid",
              // borderWidth: 0.5,
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                marginLeft: 20,
                color:
                  hover === "all"
                    ? BlackAndWhite.secondary
                    : BlackAndWhite.primary,
              }}
            >
              ALL
            </div>
          </div>
          {data.map((type, index) => {
            return (
              <div
                onMouseOver={() => setHover(index)}
                onMouseOut={() => setHover(null)}
                onClick={() => {
                  setOpen(false);
                  setType(type.storeName);
                  setSelectedStore(type.storeName);
                  setSelectedStoreId(type.storeId);
                }}
                style={{
                  backgroundColor:
                    hover === index
                      ? BlackAndWhite.primary
                      : BlackAndWhite.secondary,
                  width: "100%",
                  height: 40,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 100,
                  // borderStyle: "solid",
                  // borderWidth: 0.5,
                }}
                key={index}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                    marginLeft: 20,
                    color:
                      hover === index
                        ? BlackAndWhite.secondary
                        : BlackAndWhite.primary,
                  }}
                >
                  {type.storeName}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StoreDropDown;
